module.exports = __webpack_public_path__ + "img/banner-quiz-challenge.64a7b48f.png";